import { NgModule } from '@angular/core';
import { AutofocusDirective } from '@shared/directives/autofocus.directive';
import { QrcodeSvgModule } from '@larscom/ng-qrcode-svg';

@NgModule({
  imports: [AutofocusDirective, QrcodeSvgModule],
})
export class AuthModule {}
